var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-canvas",on:{"click":_vm.onClick}},[_c('canvas',{staticStyle:{"width":"100%"},attrs:{"id":"s-canvas","width":_vm.$store.state.isMB?_vm.contentWidth:_vm.contentWidth,"height":_vm.contentHeight}})])
}
var staticRenderFns = []

export { render, staticRenderFns }